<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">
    <div class="row">
      <ol class="breadcrumb">
        <li><a href="#" >{{ 'global.menu.home'|translate }}</a></li>
        <li class="active">{{ 'global.menu.riskProfile'|translate }}</li>
      </ol>
    </div>
    <div class="col-md-12 section">
      <div class="card mb-3">
        <div class="card-header bg-transparent">
          <h5 style="margin: 0px; margin-bottom: 2rem;">{{'global.menu.riskProfile' | translate}}</h5>
          <div *ngIf="error" class="alert alert-danger alert-dismissable">
            {{ errorMessage }}
          </div>
        </div>
        <div class="card-body">
            <div class="row" style="margin-left: 1rem;">
              <div *ngIf="showQuestionaire">
                <div *ngFor="let q of riskProfileQuestions; let i = index" >
                  <label for="opt-label" class="col-form-label">{{i + 1}}. {{ ('calculator.pensionCalculatorQuestionaire.' + q.question) | translate }}</label>
                  <div *ngFor="let opt of q.options">
                    <div class="flex-container" style="margin-bottom: 0px;">
                      <div class="flex-item-index">
                        <input
                            type="radio"
                            [name]="'question_' + i"
                            [value]="opt.value"
                            (change)="selectAnswer(i, opt.value)"
                            required
                          />
                      </div>
                      <div class="flex-item-text">
                        <label for="opt-label" class="col-form-label">{{ ('calculator.pensionCalculatorQuestionaire.' + opt.label) | translate }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <section *ngIf="showScore">
                <div class="risk-profile-item risk-profile-container">
                  <p class="risk-score">{{'calculator.pensionCalculator.scoreOut' | translate}}: <strong>{{ totalValue }}</strong></p>
                </div>
                <div class="risk-profile-item risk-profile-container">
                  <p class="risk-profile">{{'calculator.pensionCalculator.profileRisk' | translate}}: <strong>{{ ('calculator.pensionCalculatorQuestionaire.' + riskProfileResult?.riskProfile) | translate }}</strong></p>
                </div>
                <div class="risk-profile-item risk-profile-container">
                  <p class="risk-definition">{{'calculator.pensionCalculator.def' | translate}}: <strong>{{ ('calculator.pensionCalculatorQuestionaire.' + riskProfileResult?.definition) | translate }}</strong></p>
                </div>
                <div class="risk-profile-item risk-profile-container">
                  <p class="recommended-invest">{{'calculator.pensionCalculator.toif' | translate}}: <strong>{{ ('calculator.pensionCalculatorQuestionaire.' + riskProfileResult?.investOption) | translate }}</strong></p>
                </div>

                <p class="mandatoryField" style="margin-bottom: 10px; margin-top: 25px"><i>{{'calculator.pensionCalculator.riskprofilefield' | translate}}</i></p>
              </section>
            </div>
            <div class="row">
              <div class="modal-text text-centert" style="display: flex;justify-content: center; gap: 2rem; padding-top: 2rem;">
                <button *ngIf="showQuestionaire" class="btn btn-primary" (click)="nextBtn()">Submit</button>
                <button *ngIf="showScore" class="btn btn-warning" (click)="retryBtn()">Retry</button>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>